export const REPORT_SIDEBAR_GROUP_ID = 'reportSidebar';
export const ROWS_PER_REQUEST_LIMIT = 200;

export const REPORT_TYPES = {
  PERSON: 'person',
  ACCOUNT: 'account',
  OPPORTUNITY: 'opportunity',
};
